import React from 'react';
import { string, bool, func } from 'prop-types';
import Dialog from '../../atoms/Dialog';
import { Container, Message, Title, OKButton } from './alert.styles';

function Alert({
  title,
  message,
  showDialog,
  onClickOutside
}) {
  return /*#__PURE__*/React.createElement(Dialog, {
    type: "alert",
    position: "center",
    showClose: false,
    visible: showDialog,
    onClickOutside: onClickOutside,
    portal: true
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Message, null, message), /*#__PURE__*/React.createElement(OKButton, {
    full: true,
    onClick: onClickOutside
  }, "Entendi")));
}

process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  title: string,
  message: string,
  showDialog: bool,
  showClose: bool,
  onClickOutside: func
} : void 0;
export default Alert;